import React from "react";
import { useDispatch } from "react-redux";
import useLanguageChange from "../../../hooks/useLanguageChange";
import { setIsScreenShareInfoOpen } from "../../../reducers/twilioEvents-reducer";
import { handleOnScreenShare } from "./ScreenShareUtils";

const OngoingScreenShareInfo = () => {
    const localisedValues = useLanguageChange();
    const dispatch = useDispatch();

    const handleCloseInfoBar = () => {
        dispatch(setIsScreenShareInfoOpen(false));
    };

    return (
        <div className='ongoing-share-screen-info' data-testid='onGoing-screeenShare'>
            <div className='ongoing-share-screen-info-in'>
                <div className='ongoing-share-screen-text'>
                    <div className='share-screen-icon'>
                        <span className='for-icon icon-share-screen'></span>
                    </div>
                    <div className='share-screen-text'>{localisedValues["screen_share_to_everyone"]}</div>
                </div>
                <div className='share-screen-right button-inline d-flex align-items-center'>
                    <div className='button'>
                        <button className='btn btn-link font-weight-600 text-dec-none' onClick={handleOnScreenShare}>
                            {localisedValues["stop_share_screen"]}
                        </button>
                    </div>
                    <div className='button'>
                        <button className='btn hide-button' onClick={handleCloseInfoBar}>
                            <span className='btn-icon icon-close-light'></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OngoingScreenShareInfo;
